import React from 'react';
import { useScale } from '@/hooks/useScale.ts';

interface ScaledThemeProps {
  children: React.ReactNode;
}

export function ScaledTheme({ children }: ScaledThemeProps) {
  const { scale } = useScale();

  React.useEffect(() => {
    // Apply scaling via Radix UI data-scaling attribute
    const radixThemeElements = document.querySelectorAll('.radix-themes');
    radixThemeElements.forEach(element => {
      // Convert scale value to percentage for Radix UI
      const scalePercentage = Math.round(parseFloat(scale) * 100);
      element.setAttribute('data-scaling', `${scalePercentage}%`);
    });

    // Also set CSS custom property for custom components
    document.documentElement.style.setProperty('--interface-scale', scale);
  }, [scale]);

  return <>{children}</>;
}
